import { Component, OnInit } from '@angular/core';
import {LocalStorageService} from '../../../../../api/services/localStorage';
import {LoggedUser} from '../../../../types/loggedUser';
import {Country} from '../../registration-dialog/types/country.types';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {User} from '../../../../types/user';
import {Competitor, Role} from '../../../../types/competitor';
import {Language} from '../../language-switcher/types/language-switcher.types';
import {LoggedCompetitor} from '../../../../types/loggedCompetitor';
import {UntypedFormControl, Validators} from '@angular/forms';
import {HttpHandlingService} from '../../../../../api/services/http-handling.service';
import {MatDialogRef} from '@angular/material/dialog';
import {CountryService} from '../../../../../api/services/country.service';
import {SERVER_API_URL} from '../../../../types/app.constants';

@Component({
  selector: 'app-add-competitor-card',
  templateUrl: './add-competitor-card.component.html',
  styleUrls: ['./add-competitor-card.component.css']
})
export class AddCompetitorCardComponent implements OnInit {

  firstName: string;
  lastName: string;
  selectedCountry: string;
  idNumber: string;
  dateOfBirth: Date;
  address: string;
  phone: string;

  country = Country;
  countries = [];

  countryFieldControl = new UntypedFormControl('', Validators.required);
  firstNameFieldControl = new UntypedFormControl('', Validators.required);
  lastNameFieldControl = new UntypedFormControl('', Validators.required);
  idNumberFieldControl = new UntypedFormControl('', Validators.required);
  dateOfBirthFieldControl = new UntypedFormControl('', Validators.required);
  addressFieldControl = new UntypedFormControl('', Validators.required);
  phoneFieldControl = new UntypedFormControl('', Validators.required);

  serverIsDown = false;

  constructor(private http: HttpClient, private localStorage: LocalStorageService, private httpHandlingService: HttpHandlingService,
              public dialogRef: MatDialogRef<AddCompetitorCardComponent>, private countryService: CountryService) {}

  ngOnInit(): void {
    this.countries = Object.values(this.country);
  }

  /**
   * function which provides error messages in the process of updating competitor card
   * @param fieldControl with information about desired field (firstName, lastName, ...)
   */
  getErrorMessage(fieldControl: UntypedFormControl): string {
    return this.httpHandlingService.handleUserErrorOutput(fieldControl);
  }

  /**
   * function for creating the competitor with provided data
   */
  onSaveCompetitorCard(): void {
    const createCompetitorURL = SERVER_API_URL + '/api/competitors';
    if (this.localStorage.get('loggedUser') !== null) {
      const loggedUser = this.localStorage.get('loggedUser') as LoggedUser;
      const competitor = new Competitor(null, this.countryService.transformCountryToCountryCode(this.selectedCountry), this.firstName,
        this.lastName, this.idNumber, this.dateOfBirth, this.address, this.phone, Role.USER, loggedUser.id);
      this.http.post<Competitor>(createCompetitorURL, competitor,
        {headers: this.httpHandlingService.authorizationHeaders()}).subscribe(result => {
          const competitorFromServer = result as Competitor;
          const loggedCompetitor = new LoggedCompetitor(competitorFromServer.id, competitorFromServer.firstName,
            competitorFromServer.lastName, competitorFromServer.role, competitorFromServer.userId);
          this.localStorage.set('loggedCompetitor', loggedCompetitor);
          loggedUser.language = this.getLanguageFromCountry(this.selectedCountry);
          this.localStorage.set('loggedUser', loggedUser);
        }, (error: HttpErrorResponse) => this.handleCreateErrors(error),
        () => { this.dialogRef.close(); window.location.reload(); });
    }
  }

  getLanguageFromCountry(country: string): Language {
    switch (country) {
      case 'Slovakia': return Language.SK;
      case 'Czech Republic': return Language.CZ;
      case 'Poland': return Language.PL;
      case 'Hungary': return Language.HU;
      case 'Romania': return Language.RO;
      default: return Language.EN;
    }
  }

  /**
   * function for evaluating, if all necessary fields are filled
   * this function disables button, if all data are not provided
   */
  allFieldsAreFilled(): boolean {
    return !(this.countryFieldControl.valid && this.firstNameFieldControl.valid && this.lastNameFieldControl.valid &&
      this.idNumberFieldControl.valid && this.dateOfBirthFieldControl.valid && this.addressFieldControl.valid &&
      this.phoneFieldControl.valid);
  }

  /**
   * function for handling HTTP errors in the process of newly added competitor card
   */
  handleCreateErrors(error: HttpErrorResponse): void {
    if (error.status === 0) {
      this.serverIsDown = true;
    }
  }
}
